module.exports = __webpack_public_path__ + "908e4d2e/img/splash-icon.07a7c465.svg";